import styled from "@emotion/styled"
import DialogTitle from "@mui/material/DialogTitle"
import { Dialog } from "@mui/material"

const MediaMangerDialogTitle = styled(DialogTitle)`
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  
  .close-button {
    position: absolute;
    top: 17px;
    right: 30px;
    font-size: 30px;
    cursor: pointer;
    border-radius: 50%;
    padding: 2px;
    color: white;
    transition: all 0.3s ease;
    &:hover {
      transition: all 0.3s ease;
      background-color: rgba(255, 255, 255, 0.2);
      transform: scale(1.1);
    }
  }
`

const MediaManagerWrapper = styled.div`
  padding: 20px;
  height: 100vh;
  background-color: var(--cms-surface-primary);
  color: var(--cms-text-primary);
  
  .MuiTab-root {
    font-weight: 600;
    text-transform: none;
    font-size: 14px;
  }
  
  .MuiTabs-indicator {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    height: 3px;
  }
`

const StyledFileDropZone = styled.div`
  border: 2px dashed #667eea;
  border-radius: 12px;
  margin: 25px 0;
  padding: 40px 35px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #764ba2;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    transform: translateY(-2px);
  }
  
  &.drag-active {
    border-color: #4caf50;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(139, 195, 74, 0.1) 100%);
    transform: scale(1.02);
  }
  
  &.drag-reject {
    border-color: #f44336;
    background: linear-gradient(135deg, rgba(244, 67, 54, 0.1) 0%, rgba(255, 87, 34, 0.1) 100%);
    transform: scale(0.98);
  }
  
  p {
    margin: 0;
    color: #667eea;
    font-weight: 500;
  }
`

const StyledFileUploadCardZone = styled.ul`
  list-style: none;
  margin: 20px 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
`

const StyledFileUploadCard = styled.li`
  list-style: none;
  margin: 0;
  padding: 20px;
  min-height: 500px;
  border-radius: 12px;
  font-size: 12px;
  background: var(--cms-surface-secondary);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid var(--cms-border);
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  }
  
  &.upload-completed {
    border-color: #4caf50;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.05) 0%, rgba(139, 195, 74, 0.05) 100%);
  }

  .MuiTextField-root {
    margin: 8px 0;
    
    .MuiInputLabel-root {
      font-size: 13px;
      font-weight: 500;
    }
    
    .MuiInputBase-input {
      font-size: 13px;
    }
    
    .MuiFormHelperText-root {
      font-size: 11px;
    }
  }

  .upload-property {
    display: flex;
    min-height: 32px;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    margin: 8px 0;

    input {
      font-size: 13px;
    }
    
    &.title {
      min-height: 50px;
      font-weight: 600;
      color: var(--cms-text-primary);
    }

    &.truncated {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
      }
    }
    
    svg {
      margin-right: 8px;
      color: #667eea;
      
      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;
    
    .MuiButton-root {
      font-size: 11px;
      padding: 6px 12px;
      border-radius: 6px;
      font-weight: 600;
      text-transform: none;
    }
  }
  
  .upload-progress {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px;
    margin-top: 8px;
  }
  
  .upload-success {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(76, 175, 80, 0.1);
    border-radius: 8px;
    margin-top: 8px;
  }
`

const StyledMediaSearch = styled.div`
  .loading-label {
    font-size: 16px;
    padding: 20px;
    border: 1px solid var(--cms-border);
    border-radius: 8px;
    margin-top: 20px;
    background: var(--cms-surface-secondary);
    text-align: center;
  }
`

const StyledMediaUploadControlPanel = styled.div`
  display: flex;
  padding: 20px;
  margin: 20px 0;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 12px;
  background: var(--cms-surface-secondary);
  border: 1px solid var(--cms-border);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  
  .upload-stats {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .upload-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    
    .MuiButton-root {
      font-size: 12px;
      padding: 8px 16px;
      border-radius: 6px;
      font-weight: 600;
      text-transform: none;
    }
  }
`

const StyledMediaSearchPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background: var(--cms-surface-secondary);
  border-radius: 12px;
  border: 1px solid var(--cms-border);

  .bar {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    
    .search-btn {
      height: 56px;
      padding: 0 24px;
      border-radius: 8px;
      font-weight: 600;
      text-transform: none;
    }
  }

  .size-filter {
    display: flex;
    flex-direction: row;
    max-width: 300px;
    gap: 12px;
  }
`

const StyledMediaSearchInput = styled.input`
  display: inline-block;
  height: 56px;
  flex: 1;
  max-width: 440px;
  padding: 0 20px;
  border: 1px solid var(--cms-border);
  background: var(--cms-input-bg);
  color: var(--cms-text-primary);
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }
  
  &::placeholder {
    color: #94a3b8;
  }
`

const StyledMediaSearchSelect = styled.div`
  display: inline-block;
  width: 160px;
`

const StyledMediaSearchResults = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;

  .search-result-info {
    font-size: 16px;
    font-weight: 500;
    color: var(--cms-text-secondary);
    grid-column: 1 / -1;
    padding: 16px;
    background: var(--cms-surface-secondary);
    border-radius: 8px;
    border: 1px solid var(--cms-border);
    text-align: center;
  }
`

const StyledMediaSearchResultItem = styled(StyledFileUploadCard)`
  min-height: 350px;
  display: flex;
  flex-direction: column;

  .resource-id {
    display: flex;
    align-items: center;
    gap: 2px;
    font-weight: 600;
    color: var(--cms-text-secondary);

    .copy-id-btn {
      margin-left: auto;
      color: #1976d2;
    }
  }

  .description {
    height: 80px;
    margin-top: 12px;
    overflow: auto;
    padding: 8px;
    background: var(--cms-surface-muted);
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.4;
  }
  
  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: auto;
    padding-top: 16px;
  }
  
  .delete-btn {
    color: #ef4444;
    
    &:hover {
      background-color: rgba(239, 68, 68, 0.1);
    }
  }
`

const StyledMediaPreview = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  height: 140px;
  margin: 16px 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--cms-border);
  
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const StyledPaperDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.color ? props.color : `#667eea`)};
  color: white;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent);
    transform: rotate(45deg);
    animation: shine 3s infinite;
  }
  
  @keyframes shine {
    0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
    100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
  }
`

const StyledMediaMangerDialog = styled(Dialog)`
  .MuiPaper-root {
    width: 90vw;
    max-width: 1200px;
    height: 90vh;
    max-height: 900px;
    border-radius: 16px;
    overflow: hidden;
  }
  
  .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  
  .MuiDialogActions-root {
    padding: 16px 24px;
    background: var(--cms-surface-muted);
    border-top: 1px solid var(--cms-border);
  }
`

export {
  MediaMangerDialogTitle,
  MediaManagerWrapper,
  StyledFileDropZone,
  StyledFileUploadCardZone,
  StyledFileUploadCard,
  StyledMediaSearch,
  StyledMediaSearchPanel,
  StyledMediaSearchInput,
  StyledMediaSearchSelect,
  StyledMediaSearchResults,
  StyledMediaSearchResultItem,
  StyledMediaPreview,
  StyledPaperDiv,
  StyledMediaUploadControlPanel,
  StyledMediaMangerDialog,
}
